import * as c from '@Alternatives/Notifications/Domain/commands-core';
import VueCqrs from '@cqrs/vue-component-cqrs';
import Component from 'vue-class-component';

@Component
export default class NotificationsCommands extends VueCqrs 
{
	invokeCreateNotificationCommandV1(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number,
		name: string, description: string, enabled: boolean, alternativeStatusId: number, previousAlternativeStatusId: number | null,
		subject: string, message: string, recipientAttributeId: number | null, adHocRecipients: string, replyToEmail: string)
	{
		const cmd = new c.CreateNotificationCommandV1(workspaceId, projectId, alternativesListId, notificationId, name, description, enabled,
			alternativeStatusId, previousAlternativeStatusId, subject, message, recipientAttributeId, adHocRecipients, replyToEmail);

		this.$command(cmd, notificationId.toString()); 
	}

	invokeUpdateNotificationCommandV1(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number,
		name: string, description: string, enabled: boolean, alternativeStatusId: number, previousAlternativeStatusId: number | null,
		subject: string, message: string, recipientAttributeId: number | null, adHocRecipients: string, replyToEmail: string)
	{
		const cmd = new c.UpdateNotificationCommandV1(workspaceId, projectId, alternativesListId, notificationId, name, description, enabled,
			alternativeStatusId, previousAlternativeStatusId, subject, message, recipientAttributeId, adHocRecipients, replyToEmail);

		this.$command(cmd, notificationId.toString()); 
	}

	invokeDeleteNotificationCommandV1(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number)
	{
		const cmd = new c.DeleteNotificationCommandV1(workspaceId, projectId, alternativesListId, notificationId);
		this.$command(cmd, notificationId.toString());
	}
}